var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{attrs:{"id":"header"}},[_c('div',{staticClass:"left"}),_c('div',{staticClass:"right"},[_c('AppMenu',{on:{"reload-lobby":_vm.reloadHomePage,"logout":_vm.logout}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }